var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.778,
    height: 20.34,
    viewBox: "0 0 89.778 20.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    width: 89.778,
    height: 20.34,
    fill: "#295869"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    d: "M89.137,2.306,54.842,2.239c0-.01.013-.019.013-.03,0-.656-1.117-1.191-2.5-1.193s-2.5.527-2.5,1.183c0,.011.013.019.013.03L15.523,2.163a.642.642,0,1,0,0,1.284l36.047.07,0,1.052c-1.09.057-2.14.133-2.917.238-2.641.356-6.921,1.431-6.921,1.431l-.314,1.773a26.627,26.627,0,0,0-7.633,2.833L16.453,13.121,7.9,5.829l-.143.059.223-.611a.727.727,0,0,1,.721-.6L10.255.12a1.288,1.288,0,0,0-.89-.057A1.356,1.356,0,0,0,8.8.822L6.923,6.232l-1.659.689a.754.754,0,0,1-.54-.354L0,7.5a1.286,1.286,0,0,0,.4.8,1.361,1.361,0,0,0,.94.11l3.51-.679,5.11,6.646-3.017,1.05.327.984,2.332.4,24.933,1.336,7.327,1.786a20.589,20.589,0,0,0,6.577.242L71.99,17.383a53.56,53.56,0,0,0,6.779-1.345c2.036-.605,2.342-2.142.342-2.852a25.8,25.8,0,0,0-6.309-1.2L68.05,8.747A19.111,19.111,0,0,0,64.167,7.49c-1.686-.268-4.2-.588-4.2-.588l-2.907-2.49s-1.842.013-3.919.089l0-.98,36,.068a.642.642,0,0,0,0-1.284",
    transform: "translate(0 0)",
    fill: "#295869"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeli);
export default __webpack_public_path__ + "static/media/heli.864eef90071b9a6a91b29dd120ff1c2f.svg";
export { ForwardRef as ReactComponent };